<div class="form-member form-modal">
  <form (ngSubmit)="doSubmit()" [formGroup]="memberForm" novalidate>
    <div class="row form-modal">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label> Informe o nome </label>
              <ng-select
                class="custom"
                [items]="collection"
                bindValue="id"
                bindLabel="name"
                [ngClass]="{
                  'is-invalid': f.member.errors && !f.member.pristine
                }"
                formControlName="member"
              >
              </ng-select>
              <div *ngIf="f.member.errors && !f.member.pristine">
                <span class="error" [hidden]="!f.member.errors.required">
                  O usuário é obrigatório
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- end line -->
        <div class="row">
          <div class="col-12 text-center mt-5 mb-3">
            <button class="btn btn-default" (click)="modal.close('cancel')">
              Cancelar
            </button>
            <button
              class="btn btn-secondary btn-sm"
              type="submit"
              [disabled]="memberForm.invalid || isLoading"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
